import React from "react";
import uuid from "react-uuid";
import bsslogo from "../images/positions/bsslogo.png";

const Positions = () => {
  const companies = [
    {
      company: "Bangladesh Software Solution",
      timeline: "April 2022 - January 2023",
      website: "https://www.bssoln.com/",
      logo: bsslogo,
      position: "Software Engineer(Frontend)",
    },
  ];
  return (
    <div className="positions">
      <div className="section-heading">
        <h4>Positions</h4>
      </div>
      <div className="companies">
        {
          companies.map(company => 
          <div key={uuid()} className="company-position">
            <div className="company-logo">
              <a href={company.website}> <img src={company.logo} alt="" /></a>
            </div>
            <div className="employee-details">
              <h5>{company.position}</h5>
              <p>{company.company}</p>
              <h6>{company.timeline}</h6>
            </div>
          </div>  
          )
        }
      </div>
    </div>
  );
};

export default Positions;
